/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AgentRouteRouteImport } from './routes/agent/route'
import { Route as SuperviseRouteRouteImport } from './routes/supervise/route'
import { Route as TicketsRouteRouteImport } from './routes/tickets/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminCannedRepliesRouteImport } from './routes/admin/canned-replies'
import { Route as AdminChannelAccountsRouteImport } from './routes/admin/channel-accounts'
import { Route as AdminDestinationPolicyRouteImport } from './routes/admin/destination-policy'
import { Route as AdminExtensionsRouteImport } from './routes/admin/extensions'
import { Route as AdminGrantsRouteImport } from './routes/admin/grants'
import { Route as AdminHoursRouteImport } from './routes/admin/hours'
import { Route as AdminIdentityProvidersRouteImport } from './routes/admin/identity-providers'
import { Route as AdminIvrRouteImport } from './routes/admin/ivr'
import { Route as AdminNumbersRouteImport } from './routes/admin/numbers'
import { Route as AdminQueuesRouteImport } from './routes/admin/queues'
import { Route as AdminRetentionRouteImport } from './routes/admin/retention'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminSkillsRouteImport } from './routes/admin/skills'
import { Route as AdminTeamsRouteImport } from './routes/admin/teams'
import { Route as AdminTrunksRouteImport } from './routes/admin/trunks'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminVersionsRouteImport } from './routes/admin/versions'
import { Route as AdminWebhooksRouteImport } from './routes/admin/webhooks'
import { Route as AdminWorkflowsRouteImport } from './routes/admin/workflows'
import { Route as AgentIndexRouteImport } from './routes/agent/index'
import { Route as AuthAcceptRouteImport } from './routes/auth/accept'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as ContactsContactIdRouteImport } from './routes/contacts.$contactId'
import { Route as SettingsGrantsRouteImport } from './routes/settings/grants'
import { Route as SuperviseIndexRouteImport } from './routes/supervise/index'
import { Route as SuperviseAgentsRouteImport } from './routes/supervise/agents'
import { Route as SuperviseQueuesRouteImport } from './routes/supervise/queues'
import { Route as TicketsIndexRouteImport } from './routes/tickets/index'
import { Route as TicketsTicketIdRouteImport } from './routes/tickets/$ticketId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentRouteRoute = AgentRouteRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperviseRouteRoute = SuperviseRouteRouteImport.update({
  id: '/supervise',
  path: '/supervise',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsRouteRoute = TicketsRouteRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCannedRepliesRoute = AdminCannedRepliesRouteImport.update({
  id: '/canned-replies',
  path: '/canned-replies',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminChannelAccountsRoute = AdminChannelAccountsRouteImport.update({
  id: '/channel-accounts',
  path: '/channel-accounts',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDestinationPolicyRoute = AdminDestinationPolicyRouteImport.update({
  id: '/destination-policy',
  path: '/destination-policy',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminExtensionsRoute = AdminExtensionsRouteImport.update({
  id: '/extensions',
  path: '/extensions',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGrantsRoute = AdminGrantsRouteImport.update({
  id: '/grants',
  path: '/grants',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminHoursRoute = AdminHoursRouteImport.update({
  id: '/hours',
  path: '/hours',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminIdentityProvidersRoute = AdminIdentityProvidersRouteImport.update({
  id: '/identity-providers',
  path: '/identity-providers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminIvrRoute = AdminIvrRouteImport.update({
  id: '/ivr',
  path: '/ivr',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminNumbersRoute = AdminNumbersRouteImport.update({
  id: '/numbers',
  path: '/numbers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminQueuesRoute = AdminQueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRetentionRoute = AdminRetentionRouteImport.update({
  id: '/retention',
  path: '/retention',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSkillsRoute = AdminSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTeamsRoute = AdminTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTrunksRoute = AdminTrunksRouteImport.update({
  id: '/trunks',
  path: '/trunks',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminVersionsRoute = AdminVersionsRouteImport.update({
  id: '/versions',
  path: '/versions',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminWebhooksRoute = AdminWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminWorkflowsRoute = AdminWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AgentIndexRoute = AgentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentRouteRoute,
} as any)
const AuthAcceptRoute = AuthAcceptRouteImport.update({
  id: '/auth/accept',
  path: '/auth/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsContactIdRoute = ContactsContactIdRouteImport.update({
  id: '/contacts/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsGrantsRoute = SettingsGrantsRouteImport.update({
  id: '/settings/grants',
  path: '/settings/grants',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperviseIndexRoute = SuperviseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuperviseRouteRoute,
} as any)
const SuperviseAgentsRoute = SuperviseAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => SuperviseRouteRoute,
} as any)
const SuperviseQueuesRoute = SuperviseQueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => SuperviseRouteRoute,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TicketsRouteRoute,
} as any)
const TicketsTicketIdRoute = TicketsTicketIdRouteImport.update({
  id: '/$ticketId',
  path: '/$ticketId',
  getParentRoute: () => TicketsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/agent': typeof AgentRouteRouteWithChildren
  '/supervise': typeof SuperviseRouteRouteWithChildren
  '/tickets': typeof TicketsRouteRouteWithChildren
  '/admin/canned-replies': typeof AdminCannedRepliesRoute
  '/admin/channel-accounts': typeof AdminChannelAccountsRoute
  '/admin/destination-policy': typeof AdminDestinationPolicyRoute
  '/admin/extensions': typeof AdminExtensionsRoute
  '/admin/grants': typeof AdminGrantsRoute
  '/admin/hours': typeof AdminHoursRoute
  '/admin/identity-providers': typeof AdminIdentityProvidersRoute
  '/admin/ivr': typeof AdminIvrRoute
  '/admin/numbers': typeof AdminNumbersRoute
  '/admin/queues': typeof AdminQueuesRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/admin/teams': typeof AdminTeamsRoute
  '/admin/trunks': typeof AdminTrunksRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/versions': typeof AdminVersionsRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/admin/workflows': typeof AdminWorkflowsRoute
  '/auth/accept': typeof AuthAcceptRoute
  '/auth/login': typeof AuthLoginRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/settings/grants': typeof SettingsGrantsRoute
  '/supervise/agents': typeof SuperviseAgentsRoute
  '/supervise/queues': typeof SuperviseQueuesRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/admin/': typeof AdminIndexRoute
  '/agent/': typeof AgentIndexRoute
  '/supervise/': typeof SuperviseIndexRoute
  '/tickets/': typeof TicketsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/canned-replies': typeof AdminCannedRepliesRoute
  '/admin/channel-accounts': typeof AdminChannelAccountsRoute
  '/admin/destination-policy': typeof AdminDestinationPolicyRoute
  '/admin/extensions': typeof AdminExtensionsRoute
  '/admin/grants': typeof AdminGrantsRoute
  '/admin/hours': typeof AdminHoursRoute
  '/admin/identity-providers': typeof AdminIdentityProvidersRoute
  '/admin/ivr': typeof AdminIvrRoute
  '/admin/numbers': typeof AdminNumbersRoute
  '/admin/queues': typeof AdminQueuesRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/admin/teams': typeof AdminTeamsRoute
  '/admin/trunks': typeof AdminTrunksRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/versions': typeof AdminVersionsRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/admin/workflows': typeof AdminWorkflowsRoute
  '/auth/accept': typeof AuthAcceptRoute
  '/auth/login': typeof AuthLoginRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/settings/grants': typeof SettingsGrantsRoute
  '/supervise/agents': typeof SuperviseAgentsRoute
  '/supervise/queues': typeof SuperviseQueuesRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/admin': typeof AdminIndexRoute
  '/agent': typeof AgentIndexRoute
  '/supervise': typeof SuperviseIndexRoute
  '/tickets': typeof TicketsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/agent': typeof AgentRouteRouteWithChildren
  '/supervise': typeof SuperviseRouteRouteWithChildren
  '/tickets': typeof TicketsRouteRouteWithChildren
  '/admin/canned-replies': typeof AdminCannedRepliesRoute
  '/admin/channel-accounts': typeof AdminChannelAccountsRoute
  '/admin/destination-policy': typeof AdminDestinationPolicyRoute
  '/admin/extensions': typeof AdminExtensionsRoute
  '/admin/grants': typeof AdminGrantsRoute
  '/admin/hours': typeof AdminHoursRoute
  '/admin/identity-providers': typeof AdminIdentityProvidersRoute
  '/admin/ivr': typeof AdminIvrRoute
  '/admin/numbers': typeof AdminNumbersRoute
  '/admin/queues': typeof AdminQueuesRoute
  '/admin/retention': typeof AdminRetentionRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/skills': typeof AdminSkillsRoute
  '/admin/teams': typeof AdminTeamsRoute
  '/admin/trunks': typeof AdminTrunksRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/versions': typeof AdminVersionsRoute
  '/admin/webhooks': typeof AdminWebhooksRoute
  '/admin/workflows': typeof AdminWorkflowsRoute
  '/auth/accept': typeof AuthAcceptRoute
  '/auth/login': typeof AuthLoginRoute
  '/contacts/$contactId': typeof ContactsContactIdRoute
  '/settings/grants': typeof SettingsGrantsRoute
  '/supervise/agents': typeof SuperviseAgentsRoute
  '/supervise/queues': typeof SuperviseQueuesRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/admin/': typeof AdminIndexRoute
  '/agent/': typeof AgentIndexRoute
  '/supervise/': typeof SuperviseIndexRoute
  '/tickets/': typeof TicketsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/agent'
    | '/supervise'
    | '/tickets'
    | '/admin/canned-replies'
    | '/admin/channel-accounts'
    | '/admin/destination-policy'
    | '/admin/extensions'
    | '/admin/grants'
    | '/admin/hours'
    | '/admin/identity-providers'
    | '/admin/ivr'
    | '/admin/numbers'
    | '/admin/queues'
    | '/admin/retention'
    | '/admin/roles'
    | '/admin/skills'
    | '/admin/teams'
    | '/admin/trunks'
    | '/admin/users'
    | '/admin/versions'
    | '/admin/webhooks'
    | '/admin/workflows'
    | '/auth/accept'
    | '/auth/login'
    | '/contacts/$contactId'
    | '/settings/grants'
    | '/supervise/agents'
    | '/supervise/queues'
    | '/tickets/$ticketId'
    | '/admin/'
    | '/agent/'
    | '/supervise/'
    | '/tickets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/canned-replies'
    | '/admin/channel-accounts'
    | '/admin/destination-policy'
    | '/admin/extensions'
    | '/admin/grants'
    | '/admin/hours'
    | '/admin/identity-providers'
    | '/admin/ivr'
    | '/admin/numbers'
    | '/admin/queues'
    | '/admin/retention'
    | '/admin/roles'
    | '/admin/skills'
    | '/admin/teams'
    | '/admin/trunks'
    | '/admin/users'
    | '/admin/versions'
    | '/admin/webhooks'
    | '/admin/workflows'
    | '/auth/accept'
    | '/auth/login'
    | '/contacts/$contactId'
    | '/settings/grants'
    | '/supervise/agents'
    | '/supervise/queues'
    | '/tickets/$ticketId'
    | '/admin'
    | '/agent'
    | '/supervise'
    | '/tickets'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/agent'
    | '/supervise'
    | '/tickets'
    | '/admin/canned-replies'
    | '/admin/channel-accounts'
    | '/admin/destination-policy'
    | '/admin/extensions'
    | '/admin/grants'
    | '/admin/hours'
    | '/admin/identity-providers'
    | '/admin/ivr'
    | '/admin/numbers'
    | '/admin/queues'
    | '/admin/retention'
    | '/admin/roles'
    | '/admin/skills'
    | '/admin/teams'
    | '/admin/trunks'
    | '/admin/users'
    | '/admin/versions'
    | '/admin/webhooks'
    | '/admin/workflows'
    | '/auth/accept'
    | '/auth/login'
    | '/contacts/$contactId'
    | '/settings/grants'
    | '/supervise/agents'
    | '/supervise/queues'
    | '/tickets/$ticketId'
    | '/admin/'
    | '/agent/'
    | '/supervise/'
    | '/tickets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AgentRouteRoute: typeof AgentRouteRouteWithChildren
  SuperviseRouteRoute: typeof SuperviseRouteRouteWithChildren
  TicketsRouteRoute: typeof TicketsRouteRouteWithChildren
  AuthAcceptRoute: typeof AuthAcceptRoute
  AuthLoginRoute: typeof AuthLoginRoute
  ContactsContactIdRoute: typeof ContactsContactIdRoute
  SettingsGrantsRoute: typeof SettingsGrantsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent': {
      id: '/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AgentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supervise': {
      id: '/supervise'
      path: '/supervise'
      fullPath: '/supervise'
      preLoaderRoute: typeof SuperviseRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets': {
      id: '/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof TicketsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/canned-replies': {
      id: '/admin/canned-replies'
      path: '/canned-replies'
      fullPath: '/admin/canned-replies'
      preLoaderRoute: typeof AdminCannedRepliesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/channel-accounts': {
      id: '/admin/channel-accounts'
      path: '/channel-accounts'
      fullPath: '/admin/channel-accounts'
      preLoaderRoute: typeof AdminChannelAccountsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/destination-policy': {
      id: '/admin/destination-policy'
      path: '/destination-policy'
      fullPath: '/admin/destination-policy'
      preLoaderRoute: typeof AdminDestinationPolicyRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/extensions': {
      id: '/admin/extensions'
      path: '/extensions'
      fullPath: '/admin/extensions'
      preLoaderRoute: typeof AdminExtensionsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/grants': {
      id: '/admin/grants'
      path: '/grants'
      fullPath: '/admin/grants'
      preLoaderRoute: typeof AdminGrantsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/hours': {
      id: '/admin/hours'
      path: '/hours'
      fullPath: '/admin/hours'
      preLoaderRoute: typeof AdminHoursRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/identity-providers': {
      id: '/admin/identity-providers'
      path: '/identity-providers'
      fullPath: '/admin/identity-providers'
      preLoaderRoute: typeof AdminIdentityProvidersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/ivr': {
      id: '/admin/ivr'
      path: '/ivr'
      fullPath: '/admin/ivr'
      preLoaderRoute: typeof AdminIvrRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/numbers': {
      id: '/admin/numbers'
      path: '/numbers'
      fullPath: '/admin/numbers'
      preLoaderRoute: typeof AdminNumbersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/queues': {
      id: '/admin/queues'
      path: '/queues'
      fullPath: '/admin/queues'
      preLoaderRoute: typeof AdminQueuesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/retention': {
      id: '/admin/retention'
      path: '/retention'
      fullPath: '/admin/retention'
      preLoaderRoute: typeof AdminRetentionRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/skills': {
      id: '/admin/skills'
      path: '/skills'
      fullPath: '/admin/skills'
      preLoaderRoute: typeof AdminSkillsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/teams': {
      id: '/admin/teams'
      path: '/teams'
      fullPath: '/admin/teams'
      preLoaderRoute: typeof AdminTeamsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/trunks': {
      id: '/admin/trunks'
      path: '/trunks'
      fullPath: '/admin/trunks'
      preLoaderRoute: typeof AdminTrunksRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/versions': {
      id: '/admin/versions'
      path: '/versions'
      fullPath: '/admin/versions'
      preLoaderRoute: typeof AdminVersionsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/webhooks': {
      id: '/admin/webhooks'
      path: '/webhooks'
      fullPath: '/admin/webhooks'
      preLoaderRoute: typeof AdminWebhooksRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/workflows': {
      id: '/admin/workflows'
      path: '/workflows'
      fullPath: '/admin/workflows'
      preLoaderRoute: typeof AdminWorkflowsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/agent/': {
      id: '/agent/'
      path: '/'
      fullPath: '/agent/'
      preLoaderRoute: typeof AgentIndexRouteImport
      parentRoute: typeof AgentRouteRoute
    }
    '/auth/accept': {
      id: '/auth/accept'
      path: '/auth/accept'
      fullPath: '/auth/accept'
      preLoaderRoute: typeof AuthAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/$contactId': {
      id: '/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof ContactsContactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/grants': {
      id: '/settings/grants'
      path: '/settings/grants'
      fullPath: '/settings/grants'
      preLoaderRoute: typeof SettingsGrantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supervise/': {
      id: '/supervise/'
      path: '/'
      fullPath: '/supervise/'
      preLoaderRoute: typeof SuperviseIndexRouteImport
      parentRoute: typeof SuperviseRouteRoute
    }
    '/supervise/agents': {
      id: '/supervise/agents'
      path: '/agents'
      fullPath: '/supervise/agents'
      preLoaderRoute: typeof SuperviseAgentsRouteImport
      parentRoute: typeof SuperviseRouteRoute
    }
    '/supervise/queues': {
      id: '/supervise/queues'
      path: '/queues'
      fullPath: '/supervise/queues'
      preLoaderRoute: typeof SuperviseQueuesRouteImport
      parentRoute: typeof SuperviseRouteRoute
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof TicketsRouteRoute
    }
    '/tickets/$ticketId': {
      id: '/tickets/$ticketId'
      path: '/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof TicketsTicketIdRouteImport
      parentRoute: typeof TicketsRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminCannedRepliesRoute: typeof AdminCannedRepliesRoute
  AdminChannelAccountsRoute: typeof AdminChannelAccountsRoute
  AdminDestinationPolicyRoute: typeof AdminDestinationPolicyRoute
  AdminExtensionsRoute: typeof AdminExtensionsRoute
  AdminGrantsRoute: typeof AdminGrantsRoute
  AdminHoursRoute: typeof AdminHoursRoute
  AdminIdentityProvidersRoute: typeof AdminIdentityProvidersRoute
  AdminIvrRoute: typeof AdminIvrRoute
  AdminNumbersRoute: typeof AdminNumbersRoute
  AdminQueuesRoute: typeof AdminQueuesRoute
  AdminRetentionRoute: typeof AdminRetentionRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminSkillsRoute: typeof AdminSkillsRoute
  AdminTeamsRoute: typeof AdminTeamsRoute
  AdminTrunksRoute: typeof AdminTrunksRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminVersionsRoute: typeof AdminVersionsRoute
  AdminWebhooksRoute: typeof AdminWebhooksRoute
  AdminWorkflowsRoute: typeof AdminWorkflowsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminCannedRepliesRoute: AdminCannedRepliesRoute,
  AdminChannelAccountsRoute: AdminChannelAccountsRoute,
  AdminDestinationPolicyRoute: AdminDestinationPolicyRoute,
  AdminExtensionsRoute: AdminExtensionsRoute,
  AdminGrantsRoute: AdminGrantsRoute,
  AdminHoursRoute: AdminHoursRoute,
  AdminIdentityProvidersRoute: AdminIdentityProvidersRoute,
  AdminIvrRoute: AdminIvrRoute,
  AdminNumbersRoute: AdminNumbersRoute,
  AdminQueuesRoute: AdminQueuesRoute,
  AdminRetentionRoute: AdminRetentionRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminSkillsRoute: AdminSkillsRoute,
  AdminTeamsRoute: AdminTeamsRoute,
  AdminTrunksRoute: AdminTrunksRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminVersionsRoute: AdminVersionsRoute,
  AdminWebhooksRoute: AdminWebhooksRoute,
  AdminWorkflowsRoute: AdminWorkflowsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AgentRouteRouteChildren {
  AgentIndexRoute: typeof AgentIndexRoute
}

const AgentRouteRouteChildren: AgentRouteRouteChildren = {
  AgentIndexRoute: AgentIndexRoute,
}

const AgentRouteRouteWithChildren = AgentRouteRoute._addFileChildren(
  AgentRouteRouteChildren,
)

interface SuperviseRouteRouteChildren {
  SuperviseAgentsRoute: typeof SuperviseAgentsRoute
  SuperviseQueuesRoute: typeof SuperviseQueuesRoute
  SuperviseIndexRoute: typeof SuperviseIndexRoute
}

const SuperviseRouteRouteChildren: SuperviseRouteRouteChildren = {
  SuperviseAgentsRoute: SuperviseAgentsRoute,
  SuperviseQueuesRoute: SuperviseQueuesRoute,
  SuperviseIndexRoute: SuperviseIndexRoute,
}

const SuperviseRouteRouteWithChildren = SuperviseRouteRoute._addFileChildren(
  SuperviseRouteRouteChildren,
)

interface TicketsRouteRouteChildren {
  TicketsTicketIdRoute: typeof TicketsTicketIdRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
}

const TicketsRouteRouteChildren: TicketsRouteRouteChildren = {
  TicketsTicketIdRoute: TicketsTicketIdRoute,
  TicketsIndexRoute: TicketsIndexRoute,
}

const TicketsRouteRouteWithChildren = TicketsRouteRoute._addFileChildren(
  TicketsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AgentRouteRoute: AgentRouteRouteWithChildren,
  SuperviseRouteRoute: SuperviseRouteRouteWithChildren,
  TicketsRouteRoute: TicketsRouteRouteWithChildren,
  AuthAcceptRoute: AuthAcceptRoute,
  AuthLoginRoute: AuthLoginRoute,
  ContactsContactIdRoute: ContactsContactIdRoute,
  SettingsGrantsRoute: SettingsGrantsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
